module.exports = __webpack_public_path__ + "media/images/gastrozabota_logo-dbb3c58ff00d16e34177bd5a35d036be.png";